import type {
  CalculatorField,
  ChoiceType,
  DropdownType,
  HeadingType,
  ImageChoiceType,
  NumberType,
  SliderType
} from './types';

export function isNumberField(field: CalculatorField): field is NumberType {
  return field.type === 'number';
}

export function isSliderField(field: CalculatorField): field is SliderType {
  return field.type === 'slider';
}

export function isHeadingField(field: CalculatorField): field is HeadingType {
  return field.type === 'heading';
}

export function isChoiceField(field: CalculatorField): field is ChoiceType {
  return field.type === 'choice';
}

export function isImageChoiceField(
  field: CalculatorField
): field is ImageChoiceType {
  return field.type === 'imageChoice';
}

export function isDropdownField(field: CalculatorField): field is DropdownType {
  return field.type === 'dropdown';
}
